import React, { useEffect, useState } from "react";

import { connect } from "react-redux";
import {
    getSkills,
    addSkill,
    clearUserSkills,
    openMainModal,
    closeMainModal,
    removeSkill,
    getCities,
    setImage,
} from "../../store/actions/index";
import { fireAnalytics } from "../../utils/firebase";
import FileUploadOnboarding from "../FileUploadOnboarding/FileUploadOnboarding.tsx";
import InputNew from "../UI/InputNew/InputNew";
import styles from "./FormularioPersonaNew.module.scss";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ArrowDownIcon } from "../../assets/svg/arrowDownIcon.svg";
import UserSkillsUpdater from "../UserSkillsUpdater/UserSkillsUpdater";
import { Search, Check, HardHat, Info, ArrowLeft } from "lucide-react";
import useIsPhone from "../../hooks/useIsPhone";

const ButtonContainer = ({ children, ...props }) => (
    <div style={{ display: "flex", gap: "10px" }} {...props}>
        {children}
    </div>
);

const FormularioPersonaNew = ({
    name,
    lastName,
    getSkills,
    addSkill,
    skills,
    userSkills,
    clearUserSkills,
    tel,
    address,
    webSite,
    file,
    removeSkill,
    openMainModal,
    closeMainModal,
    getCities,
    setImage,
}) => {
    const [showSkillsSuggestions, setShowSkillsSuggestions] = useState<boolean>(false);
    const [showSkillsList, setShowSkillsList] = useState<boolean>(false);
    const [inputValue, setInputValue] = useState<string>("");
    const [matchedSkills, setMatchedSkills] = useState<any[]>([]);
    const [isFormValid, setIsFormValid] = useState<boolean>(false);
    const [formData, setFormData] = useState<{
        name: string;
        lastName: string;
        tel: string;
        webSite: string;
    }>({
        name: name || "",
        lastName: lastName || "",
        tel: tel || "",
        webSite: webSite || "",
    });

    const [errors, setErrors] = useState<{
        name?: string;
        lastName?: string;
        tel?: string;
        webSite?: string;
        userSkills?: string;
    }>({});

    const isPhone = useIsPhone();
    const navigate = useNavigate();

    useEffect(() => {
        fireAnalytics("ob_step_2_profesional", { category: "navigation" });
        getSkills();
        
        const storedPersonaForm = localStorage.getItem("personaFormNew");
        const storedUserSkills = localStorage.getItem("userSkillsNew");
        

        if (storedPersonaForm) {
            try {
                const parsedFormData = JSON.parse(storedPersonaForm);
                setFormData(parsedFormData);
            } catch (error) {
                console.error("Error parsing stored persona form:", error);
            }
        }
        
        if (storedUserSkills) {
            try {
                const parsedUserSkills = JSON.parse(storedUserSkills);
                parsedUserSkills.forEach(skill => {
                    addSkill(skill.id);
                });
            } catch (error) {
                console.error("Error parsing stored user skills:", error);
            }
        } else {
            clearUserSkills();
        }
    }, [getSkills, addSkill, clearUserSkills]);

    const webSiteRegex = /(^[a-zA-Z_-]{3})([.]{1})([a-zA-Z0-9_.+-]+)([.]{1})([a-zA-Z_-]+)/;
    const telRegex = /[0-9+]/;

    const validateForm = () => {
        const newErrors: {
            name?: string;
            lastName?: string;
            tel?: string;
            webSite?: string;
            userSkills?: string;
        } = {};

        if (!formData.name.trim()) {
            newErrors.name = "El campo es requerido.";
        }

        if (!formData.lastName.trim()) {
            newErrors.lastName = "El campo es requerido.";
        }

        if (formData.tel && !telRegex.test(formData.tel)) {
            newErrors.tel = "Introduzca un formato válido";
        } else if (formData.tel && (formData.tel.length < 7 || formData.tel.length > 13)) {
            newErrors.tel = "Ingrese un telefono válido";
        }

        if (formData.webSite && !webSiteRegex.test(formData.webSite)) {
            newErrors.webSite = "Introduzca un formato válido";
        }

        if (!userSkills || userSkills.length === 0) {
            newErrors.userSkills = "Seleccioná al menos 1 rubro";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSpecialKey = (event) => {
        const filter = /^[a-zA-Z ]*$/;
        if (!filter.test(event.key)) {
            event.preventDefault();
        }
    };

    const handleInputChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));


        if (errors[field]) {
            setErrors(prev => ({
                ...prev,
                [field]: ""
            }));
        }

        if (field === 'name' || field === 'lastName') {
            const hasRequiredFields = (field === 'name' ? value : formData.name).trim() && 
                                   (field === 'lastName' ? value : formData.lastName).trim();
            const hasSkills = userSkills && userSkills.length > 0;
            const hasNoErrors = Object.keys(errors).length === 0;
            
            setIsFormValid(hasRequiredFields && hasSkills && hasNoErrors);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (validateForm()) {
            localStorage.setItem("personaFormNew", JSON.stringify(formData));
            localStorage.setItem("userSkillsNew", JSON.stringify(userSkills || []));
            
            navigate("/work-zones-new");
        }
    };

    useEffect(() => {
        setMatchedSkills(skills || []);
    }, [skills]);

    const handleInputSearch = (e) => {
        const value = e.target.value;
        setInputValue(value); 
        const skillsArray = skills || [];
        const filteredSkills = skillsArray.filter((skill) => {
            return skill.name.toLowerCase().includes(value.toLowerCase());
        });
        setMatchedSkills(filteredSkills);
    };

    const handleAddSkill = (id) => {
        const userSkillsArray = userSkills || [];
        if (!userSkillsArray.find((skill) => skill.id === id)) {
            addSkill(id);
        } else {
            removeSkill(id);
        }
        setShowSkillsSuggestions(false);
        setInputValue("");
    };

    const defaultPersonValues = {
        name: "Usuario",
        lastName: "Edify",
        tel: "",
        webSite: "",
    };

    const handleSkipButton = () => {
        const defaultSkillName = "Otros";
        const skillsArray = matchedSkills || [];
        const defaultSkill = skillsArray.find(skill => skill.name === defaultSkillName);
        const defaultSkills = defaultSkill ? { id: defaultSkill.id, name: defaultSkill.name } : null;

        openMainModal({
            title: "¿Estás seguro?",
            body: "Si omites este paso, se crearán valores por defecto para nombre, apellido y rubro. Los lugares de trabajo se configurarán en el siguiente paso.",
            yesLabel: "Omitir",
            noLabel: "Cancelar",
            iconType: "warning",
            confirmHandler: () => {
                if (defaultSkills) {
                    addSkill(defaultSkills.id);
                    const finalValues = {
                        ...defaultPersonValues,
                    };
                    
                    localStorage.setItem("personaFormNew", JSON.stringify(finalValues));
                    localStorage.setItem("userSkillsNew", JSON.stringify([defaultSkills]));
                    
                    navigate("/work-zones-new");
                }
                closeMainModal();
            }
        });
    };

    useEffect(() => {
        const hasRequiredFields = formData.name.trim() && formData.lastName.trim();
        const hasSkills = userSkills && userSkills.length > 0;
        const hasNoErrors = Object.keys(errors).length === 0;
        
        setIsFormValid(hasRequiredFields && hasSkills && hasNoErrors);
    }, [errors, userSkills, formData.name, formData.lastName]);

    useEffect(() => {
        const hasRequiredFields = formData.name.trim() && formData.lastName.trim();
        const hasSkills = userSkills && userSkills.length > 0;
        const hasNoErrors = Object.keys(errors).length === 0;
        
        setIsFormValid(hasRequiredFields && hasSkills && hasNoErrors);
    }, [userSkills]);

    return (
        <form onSubmit={handleSubmit} className={styles.formContainer}>
            <UserSkillsUpdater userSkills={userSkills || []} setFieldValue={() => { }} />
            <FileUploadOnboarding file={file} setImage={setImage} />

            <div className={styles.formGroup_container}>
                <div className={styles.formGroup_container_form}>
                    <h4 className={styles.formGroup_container_title}>Datos del usuario</h4>
                    <div className={styles.formGroup_inputs}>
                        <div className={styles.inputRow}>
                            <div className={styles.formGroup}>
                                <div className={styles.formGroup_title}>
                                    Nombre*
                                </div>
                                <InputNew
                                    placeholder="Ingrese su nombre"
                                    handleKey={handleSpecialKey}
                                    type="text"
                                    name="name"
                                    value={formData.name}
                                    onChange={(e) => handleInputChange('name', e.target.value)}
                                    onBlur={() => { }}
                                    className={`${errors.name ? "error" : "isValid"}`}
                                    style={{ textAlign: "left" }}
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <div className={styles.formGroup_title}>
                                    Apellido*
                                </div>
                                <InputNew
                                    placeholder="Ingrese su apellido"
                                    handleKey={handleSpecialKey}
                                    type="text"
                                    name="lastName"
                                    value={formData.lastName}
                                    onChange={(e) => handleInputChange('lastName', e.target.value)}
                                    onBlur={() => { }}
                                    className={`${errors.lastName ? "error" : "isValid"}`}
                                    style={{ textAlign: "left" }}
                                />
                            </div>
                        </div>
                        <div className={styles.inputRow}>
                            <div className={styles.formGroup}>
                                <div className={styles.formGroup_title}>
                                    Página Web
                                </div>
                                <InputNew
                                    placeholder="https://www.ejemplo.com"
                                    type="text"
                                    name="webSite"
                                    value={formData.webSite}
                                    onChange={(e) => handleInputChange('webSite', e.target.value)}
                                    onBlur={() => { }}
                                    className={`${errors.webSite ? "error" : "isValid"}`}
                                    style={{ textAlign: "left" }}
                                    handleKey={undefined}
                                />
                            </div>
                            <div className={styles.formGroup}>
                                <div className={styles.formGroup_title}>
                                    Teléfono
                                </div>
                                <InputNew
                                    placeholder="(+54) 1234-5678"
                                    type="number"
                                    name="tel"
                                    value={formData.tel}
                                    onChange={(e) => handleInputChange('tel', e.target.value)}
                                    onBlur={() => { }}
                                    className={`${errors.tel ? "error" : "isValid"}`}
                                    style={{ textAlign: "left" }}
                                    handleKey={undefined}
                                />
                                {errors.tel && <div className={styles.formGroup_errorMsg}>{errors.tel}</div>}
                            </div>
                        </div>
                        <div className={styles.formGroup_lastOne}>
                            <div className={styles.formGroup_title}>
                                Rubros*
                            </div>
                            <div className={styles.skillsContainer}>
                                <button
                                    type="button"
                                    onClick={() => setShowSkillsList(!showSkillsList)}
                                    className={styles.skillsContainer_inputContainer}
                                >
                                    <span className={styles.skillsContainer_selected}>
                                        {userSkills?.length > 0 ? (
                                            `${userSkills.length} rubro${userSkills.length > 1 ? "s" : ""} seleccionado${userSkills.length > 1 ? "s" : ""}`
                                        ) : (
                                            "Seleccionar rubros"
                                        )}
                                    </span>
                                    <ArrowDownIcon
                                        width={16}
                                        height={16}
                                        className={`${styles.arrowIcon} ${showSkillsList ? styles.arrowUp : ""}`}
                                    />
                                </button>
                                {showSkillsList && (
                                    <div className={styles.skillsContainer_list}>
                                        <div className={styles.skillsContainer_list_search}>
                                            <Search size={16} />
                                            <input
                                                type="text"
                                                placeholder="Buscar rubros..."
                                                value={inputValue}
                                                onChange={handleInputSearch}
                                                className={styles.skillsContainer_list_search_input}
                                            />
                                        </div>
                                        {matchedSkills.length > 0 ? (
                                            matchedSkills.map((skill) => (
                                                <div
                                                    key={skill.id}
                                                    className={styles.skillsContainer_list_item}
                                                    onClick={(e) => {
                                                        handleAddSkill(skill.id);
                                                        e.stopPropagation();
                                                    }}
                                                >
                                                    {skill.name}
                                                    {userSkills && userSkills.find(userSkill => userSkill.id === skill.id) && (
                                                        <span className={styles.skillsContainer_list_item_check}>
                                                            <Check size={16} />
                                                        </span>
                                                    )}
                                                </div>
                                            ))
                                        ) : (
                                            <div className={styles.skillsContainer_list_item}>No existe ese rubro</div>
                                        )}
                                    </div>
                                )}
                                {userSkills && userSkills.length > 0 ? (
                                    <div className={styles.skillsContainer_selected}>
                                        {userSkills.map((skill) => {
                                            return (
                                                <div
                                                    className={styles.skillsContainer_skillSelected}
                                                    key={skill.id}
                                                    onClick={() => removeSkill(skill.id)}
                                                >
                                                    <HardHat size={14} />
                                                    {skill.name}&nbsp;  X
                                                </div>
                                            );
                                        })}
                                    </div>
                                ) : (
                                    <div className={styles.emptyState}>
                                        <Info size={16} />
                                        <span>Seleccioná al menos un rubro</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ButtonContainer>
                <button
                    className={styles.btn_back}
                    type="button"
                    onClick={() => navigate("/select-type")}
                >
                    <ArrowLeft size={16} />
                    Volver
                </button>

                <button
                    className={styles.btn_skip}
                    type="button"
                    onClick={() => handleSkipButton()}
                >
                    {isPhone ? "Omitir" : "Omitir paso"}
                </button>
                <button
                    className={styles.btn}
                    disabled={!isFormValid}
                    type="submit"
                    onClick={() => {
                        fireAnalytics("ob_step_2_profesional_success", {
                            category: "onboarding",
                        });
                    }}
                >
                    Siguiente
                </button>
            </ButtonContainer>
        </form>
    );
};

const mapStateToProps = (state) => {
    return {
        name: state.register.personaForm?.name || "",
        lastName: state.register.personaForm?.lastName || "",
        tel: state.register.personaForm?.tel || "",
        address: state.register.personaForm?.address || "",
        webSite: state.register.personaForm?.webSite || "",
        file: state.register.file,
        skills: state.register.skills || [],
        userSkills: state.register.userSkills || [],
    };
};

export default connect(mapStateToProps, {
    getSkills,
    addSkill,
    removeSkill,
    clearUserSkills,
    openMainModal,
    closeMainModal,
    getCities,
    setImage,
})(FormularioPersonaNew);
